import React from 'react';
import { Icon } from '@chakra-ui/react';

export const SvgDownloadIcon = (props) => {
  return (
    <Icon viewBox="0 0 16 16" color="primary.base" {...props}>
      <path
        id="Path_388819"
        d="M14.778 12h-.889a.444.444 0 0 0-.444.444v2.222H2.778v-2.222A.444.444 0 0 0 2.333 12h-.889a.444.444 0 0 0-.444.444V16a.444.444 0 0 0 .444.444h13.334a.444.444 0 0 0 .444-.444v-3.556a.444.444 0 0 0-.444-.444z"
        fill="currentColor"
        transform="translate(-0.111 -1.333)"
      />
      <path
        id="Path_388820"
        d="M8.4 12.047a.222.222 0 0 0 .311 0L12.022 8.7a.348.348 0 0 0 .089-.234.356.356 0 0 0-.356-.356H9.444V1.444A.444.444 0 0 0 9 1h-.889a.444.444 0 0 0-.444.444v6.667H5.356A.356.356 0 0 0 5 8.467a.348.348 0 0 0 .089.234z"
        fill="currentColor"
        transform="translate(-0.556 -0.111)"
      />
    </Icon>
  );
};
